import { FC } from "react";
import { ChatServerActionLink } from "../../xapp/ChatServerMessage";
import { ChatChip } from "../ChatChip";
import "./ChatChips.scss";

export interface Props {
    readonly options: readonly (string | ChatServerActionLink)[];
    onOptionClick?: (option: string | ChatServerActionLink) => void;
}

/**
 * Render option list. We just follow the order.
 */
const ChatChips: FC<Props> = (props: Props) => {
    return (
        <div className="chat-chips">
            {props.options.map((option: string | ChatServerActionLink, i: number) => {
                return <ChatChip key={i} onClick={props.onOptionClick} option={option} />;
            })}
        </div>
    );
};

export default ChatChips;
